<div [class]="containerClasses()" [attr.aria-label]="ariaLabel()">
      <!-- Image -->
      @if (src() && !imageError) {
        <img
          [src]="src()"
          [alt]="alt() || effectiveName() || 'Avatar'"
          class="w-full h-full object-cover"
          (error)="onImageError()"
        />
      } @else if (effectiveName(); as n) {
        <!-- Initials fallback -->
        <span [class]="initialsClasses()">{{ initials() }}</span>
      } @else {
        <!-- Default icon fallback -->
        <svg [class]="iconClasses()" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
      }

      <!-- Status indicator -->
      @if (status() !== 'none') {
        <span [class]="statusClasses()"></span>
      }

      <!-- Badge (optional, for notifications) -->
      @if (badge(); as b) {
        <span [class]="badgeClasses()">{{ b > 99 ? '99+' : b }}</span>
      }
    </div>
